export default {
  title: 'Liity {{name}}!',
  default_program_name: 'Kanta-asiakasklubi',
  benefits: {
    earn_points: 'Kerää pisteitä jokaisesta tilauksesta',
    get_deals: 'Saat erikoisalennuksia',
    redeem_points: 'Lunasta pisteitä ilmaiseksi ruoaksi',
  },
  terms: 'Rekisteröitymällä saat sähköposti- ja tekstiviestitarjouksia yritykseltämme&nbsp;',
  buttons: {
    log_in: 'Kirjaudu sisään',
    sign_up: 'Rekisteröidy',
  },
  labels: {
    already_have_account: 'Onko sinulla jo tili?',
  },
  signup_note:
    'Rekisteröitymällä saat sähköposti- ja tekstiviestitarjouksia <0>ravintolaltamme</0> ja <1>FoodAmigosilta</1>, teknologiakumppaniltamme. Hyväksyt <2>käyttöehtomme</2> ja <3>tietosuojakäytäntömme</3>.',
};
